// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-declaration[data-v-4f803190] a,.cookie-declaration a[data-v-4f803190]{--text-opacity:1;color:#f9a91e;color:rgba(249,169,30,var(--text-opacity));text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
